// TODO: add translation when we have the final copies
export const PLACEHOLDERS = [
    'Finish my vibe coding project',
    'Launch a UGC campaign',
    'Find an editor for my book',
    'Hire a social media manager',
    'Find someone to manage my SEO',
    'Write a script for my TikTok ad',
    'Optimize my LinkedIn profile',
    'Automate my workflow with Python',
    'Develop an AI chatbot for my store',
    'Create a 3D model of my house',
    'Redesign my kitchen layout',
];

export const MOBILE_PLACEHOLDERS = [
    'Search for any service...',
    'UGC creator',
    'Book editor',
    'AI developer',
    'Resume writer',
    'Hire website designer',
    'Shopify expert',
    'Scriptwriter for YouTube',
    'Presentation designer',
    'AI chatbot developer',
];

export const MOBILE_STATIC_PLACEHOLDER = ['Hire in 700+ categories'];

export const DESKTOP_STATIC_PLACEHOLDER = ['Find talent across 700+ categories'];

export const SEARCH_SOURCE = 'brand_homepage';

export const MOBILE_WIDTH_BREAKPOINT = 600;
